
export default function mergeObjects(objectToMerge: Object, originalObject: Object, specialFieldsFormatter: Function = v => v) {

    const existingKeys = Object.keys(originalObject);

    const keysToApply = Object.keys(objectToMerge);
    keysToApply.forEach((keyToApply) => {
        if (existingKeys.includes(keyToApply)) {
            const fieldFormatter = specialFieldsFormatter(keyToApply);
            originalObject[keyToApply] = fieldFormatter(objectToMerge[keyToApply]);
        }
    });
}


// WEBPACK FOOTER //
// ./src/app/util/objectHandler.ts